import { noticeRules } from '../shared/notices';
import type { RootState } from './store';

/** Every notice currently active, most-relevant order as declared. */
export const selectActiveNotices = (state: RootState) =>
  noticeRules.filter((rule) => rule.matches(state));

export const selectCheckoutBlocked = (state: RootState) =>
  noticeRules.some((rule) => rule.blocking && rule.matches(state));
